function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapFilterWo = function SvgLivemapFilterWo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 37.998,
    viewBox: "0 0 38 37.998"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Work Orders"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3305.442-4154.112h-18.586v-11.179h-1.556v-5h21.7v5h-1.557v11.177zm-17.65-11.179v10.239h16.715v-10.239zm-1.557-4.064v3.126h19.829v-3.126zm13.5 9.145h-6.645v-2.97h6.645v2.969zm6.343-11.94h-19.218v-.938h19.218v.937zm-1.394-2.541h-16.316v-.937h16.316v.937z",
    "data-name": "Path 11611",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(-3277.792 4183.241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0z",
    "data-name": "Rectangle 4459",
    style: {
      fill: "none"
    },
    transform: "translate(4.507 4.612)"
  }))));
};
export default SvgLivemapFilterWo;